import React from 'react';

const EventsSection = () => {
  return (
    <div id="events" className="glass-section h-full">
      <div className="text-white">
        <h2 className="text-3xl lg:text-4xl font-bold mb-5 drop-shadow-xl text-center font-display">
          Upcoming Events
        </h2>
        <div className="relative pb-[112%] sm:pb-[75%] h-0 overflow-hidden rounded-xl bg-white/10 backdrop-blur-sm border border-white/20">
          <iframe
            src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=America%2FNew_York&src=trnfinc%40gmail.com&color=%23039BE5&showTitle=0&showNav=1&showDate=1&showPrint=0&showTabs=1&showCalendars=0&showTz=0&mode=AGENDA"
            className="absolute top-0 left-0 w-full h-full rounded-xl"
            frameBorder="0"
            scrolling="no"
            title="TRNF Upcoming Events Calendar"
          />
        </div>
        <p className="text-base text-white/80 text-center mt-3 drop-shadow-md">
          Stay updated with our latest events and activities!
        </p>
      </div>
    </div>
  );
};

export default EventsSection;
